import * as Immutable from 'immutable';
import {
  SET_THEME_REQUESTED,
  SET_THEME_COMPLETED,
  GET_THEME_REQUESTED,
  GET_THEME_COMPLETED,
} from '../../actions/theme/types';

const schema = {
  error: null,
  prefersDarkMode: true,
  requestingThemeMode: false,
  requestingGetThemeMode: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_THEME_REQUESTED:
      return state.set('error', null).set('requestingThemeMode', true);

    case SET_THEME_COMPLETED:
      return state
        .set('error', null)
        .set('requestingThemeMode', false)
        .set('prefersDarkMode', action.payload);

    case GET_THEME_REQUESTED:
      return state.set('error', null).set('requestingGetThemeMode', true);

    case GET_THEME_COMPLETED:
      return state
        .set('error', null)
        .set('requestingGetThemeMode', false)
        .set('prefersDarkMode', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
